import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, Dialog, Toast } from "primereact";
import { Checkbox } from "primereact/checkbox";
import { confirmDialog } from "primereact/confirmdialog";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import Card from "../../../../Base/Components/Card/Card"

import Loader from "../../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { toastShow } from "../../../../Base/Services/ToastService";
import { useForm } from "../../../../Base/Hooks/useForm";
import AutoCompleteDropdown from "../../../../Base/Components/Form/AutoCompleteDropdown";
import { getUsuariosActivos } from "../../../../Base/API/IT/Users/UserRequests";

import { chageEstadoVacantesDetalles, changeCheckList, changeEntrevista, eliminarEntrevista, EliminarVacanteDetalles, getCheckList, getDetallesVacantesPorId, getUsersPorId, GuardarDetallesVacantes, GuardarEntevistas, GuardarEntrevistas, obtenerEntrevistasPorIdVacante } from "../../../../API/RRHH/Vacantes/VacantesRequests";
import { getAspirantes } from "../../../../API/RRHH/Maestros/MaestrosRequest";

import EntrevistaModal from "./EntrevistaModal";
import CandidatosCRUD from "../Maestros/CandidatosCRUD";
import { Dropdown } from "primereact/dropdown";
import { getEstadosCategory } from "../../../../API/Global/Status/StatusRequests";

const DetallesVacantesCRUD = ({ showDialogDetalles, setShowDialogDetalles, getInfo, selected, setSelected }) => {
  const toast = useRef(null);

  const { userAuth } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [detalles, setDetalles] = useState([]);
  const [aspirantesList, setAspirantesList] = useState([]);
  const [selectedDetalles, setSelectedDetalles] = useState([]);
  const [dialogEntrevista, setDialogEntrevista] = useState(false);
  const [detalleSelected, setDetalleSelected] = useState(null);
  const [checked, setChecked] = useState(null);
  const [dialogCandidato, setDialogCandidato] = useState(false);
  const [dialogDetalleUnico, setDialogDetalleUnico] = useState(false);
  const [aspirante, setAspirante] = useState(false);
  const [usuarios, setUsuarios] = useState([]);  
  const [estados, setEstados] = useState([]);
  const [checkList, setCheckList] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState('');
  const [IdCheckList, setIdCheckList] = useState([]);
  const [entrevistas, setEntrevistas] = useState([]);

  const initialValues = {
    IdVacanteDetalle: -1,
    NotificacionIngreso: false,
    Entrevista: false,
    SolicitudConFoto: false,
    Demografica: false,
    Contrato: false,
    EvaluacionLogica: false,
    CopiaVacunas: false,
    EvaluacionMedica: false,
    Curriculum: false,
    CopiaDiploma: false,
    AntecedentesPoliciales: false,
    AntecedentesPenales: false,
    ConstanciasTrabajo: false,
    CartasReferencias: false,
    Croquis: false, 
    CopiaIdentidades: false,
    IdentidadPropia: false,
    CopiaRTN: false,
    InformacionAperturaCuentas: false,
    ManualInduccion: false,
    ManualInduccion: false,
    InfromacionGeneral: false,
    InduccionFormasPagos: false,
    ResenaHistorica: false,
    DateEntrevista: null,
  };
  
  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);
  

  const getValoresIniciales = async () => {
    setLoading(true);
    
    const IdVacante = selected[0]?.IdVacante

    const detallesTempo = await getDetallesVacantesPorId(IdVacante)
    setDetalles(detallesTempo)

    const checkTempo = await getCheckList()
    setCheckList(checkTempo)

    const usuariosTempo = await getUsuariosActivos()
    setUsuarios(usuariosTempo)

    const estadosTempo = await getEstadosCategory('Detalles Vacantes')
    setEstados(estadosTempo)

    const aspirantesTempo = await getAspirantes()
    setAspirantesList(aspirantesTempo.filter(i => i?.IdStatus === 70))
    
    setLoading(false);
  };

  const getValoresInicialesDialog = async () => {
    setLoading2(true);

    const usuariosTempo = await getUsuariosActivos()
    setUsuarios(usuariosTempo)

    
    if(selectedDetalles[0]?.IdVacanteDetalle > 0){
      let checksMarcados = selectedDetalles[0]?.IdChecks?.split(',').map((id) => parseInt(id)); 
      setIdCheckList(checksMarcados ? checksMarcados : []);
      let usuariosEntrevista = await getUsersPorId(selectedDetalles[0]?.IdUsersEntrevista)
      setSelectedUsers(usuariosEntrevista)
      const resp = await obtenerEntrevistasPorIdVacante(selectedDetalles[0]?.IdVacanteDetalle)
      setEntrevistas(resp)
      if(resp?.length === 0){
        let checksMarcados = selectedDetalles[0]?.IdChecks?.split(',').map((id) => parseInt(id)).filter((id) => id !== 2);
        setIdCheckList(checksMarcados ? checksMarcados : []);
      }
      setValues({
        ...selectedDetalles[0],
        IdAspirante: selectedDetalles[0]?.IdAspirante,
        NombreCompleto: selectedDetalles[0]?.NombreCompleto,
        DateEntrevista: new Date(selectedDetalles[0]?.DateEntrevistaStr),
      })
    }else{
      setIdCheckList([])
      setValues({
        ...initialValues,
        DateEntrevista: null,
      })
    }
    setLoading2(false);
  };

  const onHide = () => {
    setShowDialogDetalles(false);
    getValoresIniciales()
    setSelected([])
    getInfo()
  };

  const onHide2 = () => {
    setDialogDetalleUnico(false);
    getValoresIniciales()
    setValues([])
    setSelectedUsers('')
    setSelectedDetalles([])
    setEntrevistas([])
  };

  const eliminarDetalles = async () => {
    let IdVacantesDetalle = selectedDetalles.map(i => i?.IdVacanteDetalle).join(',')
    confirmDialog({
      message: "¿Esta seguro que desea eliminar los detalles selecccionados?",
      header: "Eliminar",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sí",
      rejectLabel: "No",
      style: { backgroundColor: "white" },
      accept: async () => {
        setLoading(true)
        const resp = await EliminarVacanteDetalles(IdVacantesDetalle)
        toastShow(toast, 'success', 'Eliminado', 'Detalle eliminado correctamente.')
        getValoresIniciales()
        setLoading(false)
        setSelectedDetalles([])
      },
      reject: () => {},
    });
  }

  const verificarInfo = () => {
    let error = {};

    if(values?.IdVacanteDetalle > 0){


    }else{
      if(!values?.NombreCompleto?.IdAspirante){
        error.IdAspirante = true;
        error.error = true;
      }
    }

    // if(IdCheckList.includes(2)){
    //   if(selectedUsers.length <= 0){
    //     error.selectedUsers = true;
    //     error.error = true;
    //   }
    //   if (!values.DateEntrevista) {
    //     error.DateEntrevista = true;
    //     error.error = true;
    //   }
    //   if (!values.ComentarioEntrevista) {
    //     error.ComentarioEntrevista = true;
    //     error.error = true;
    //   }
    // }

    setError(error);
    return error;
  };

  const otraFuncionDeGuardar = async () => {
    let e = verificarInfo()

    if(!e.error){
      const nuevoIdAspirante = values?.NombreCompleto?.IdAspirante || values?.IdAspirante;
      
      const yaExiste = detalles.some(d => d?.IdAspirante === nuevoIdAspirante && d?.IdVacanteDetalle !== values?.IdVacanteDetalle && d.IdStatus !== 87);
      if(yaExiste){
        toastShow( toast, "error", "Error", "Ya existe el candidato en esta Vacante.");
        return
      }

      if (IdCheckList?.includes(2)) {
        if (entrevistas.length < 1) {
          toastShow(toast, "error", "Error", "Agregue los datos de la entrevista");
          return;
        }
      
        for (let i = 0; i < entrevistas.length; i++) {
          const entrevista = entrevistas[i];
      
          if (!entrevista?.IdUser) {
            toastShow(toast, "error", "Error", `Todas las entrevistas deben tener un entrevistador asignado`);
            return;
          }
      
          if (!entrevista?.DateEntrevista) {
            toastShow(toast, "error", "Error", `Todas las entrevistas deben tener un fecha`);
            return;
          }
      
          if (!entrevista?.ComentarioEntrevista) {
            toastShow(toast, "error", "Error", `El comentario de las entrevista no puede estar vacío`);
            return;
          }
        }
      }

      const detallesEntrevista = entrevistas.map((detalle) => ({
        ...detalle[0],
        IdEntrevista: detalle.IdEntrevista,
        IdUserEntrevista: detalle?.IdUser,
        ComentarioEntrevista: detalle?.ComentarioEntrevista,
        DateEntrevista: detalle?.DateEntrevista,
        IdUserEdit: userAuth?.IdUser,
        IdStatus: IdCheckList?.includes(2) ? 5 : 7,
      }));
      
      const Datos = {
        IdVacanteDetalle: values?.IdVacanteDetalle,
        IdAspirante: values?.NombreCompleto?.IdAspirante || values?.IdAspirante,
        IdVacante: selected[0]?.IdVacante,
        IdUserCreate: userAuth?.IdUser,
        IdUserEdit: userAuth?.IdUser,
        IdChecks: IdCheckList.join(',') || null,
        DatosEntrevista: detallesEntrevista,
      }

      setLoading2(true)
      const resp = await GuardarDetallesVacantes(Datos);
      if(resp[0]?.ESTADO === 1){
        toastShow( toast, "success", "Guardado", "Candidato agregado correctamente");
        setTimeout(() => {          
          setLoading2(false)
          onHide2()
        }, 500);
      }
    }

  }

  const agregarDetalle = async (newData) => {
    const tieneIdAspiranteInvalido = detalles.some((detalle) => !detalle.IdAspirante);
    
    if (tieneIdAspiranteInvalido) {
      toastShow(toast, "error", "Error", "Todos los detalles deben tener un Aspirante.");
      return;
    }

    const tieneIdAspiranteRepetido = detalles.some((detalle, index, self) => 
      self.findIndex(d => d.IdAspirante === detalle.IdAspirante) !== index
    );

    if (tieneIdAspiranteRepetido) {
      toastShow(toast, "error", "Error", "Los detalles deben tener Aspirantes diferentes.");
      return;
    }


    let Datos
    if(newData?.length > 0){
      Datos = newData.map((detalle) => ({
        ...detalle,
        IdVacante: selected[0]?.IdVacante,
        IdUserCreate: userAuth?.IdUser,
        IdUserEdit: userAuth?.IdUser,
      }));
    }else{
      Datos = detalles.map((detalle) => ({
        ...detalle,
        IdVacante: selected[0]?.IdVacante,
        IdUserCreate: userAuth?.IdUser,
        IdUserEdit: userAuth?.IdUser,
      }));
    }

    let todosGuardadosExitosamente = true; 

    for (const detalle of Datos) {
      const resp = await GuardarDetallesVacantes(detalle);

      if (resp[0]?.ESTADO !==1) {
          todosGuardadosExitosamente = false;
      }
    }

    if (todosGuardadosExitosamente) {
      toastShow( toast, "success", "Guardado", "Datos guardados correctamente");
      getValoresIniciales()
    } else {
      toastShow( toast, "error", "Error", "Error al guardar datos.");
    }
  };
  
  const agregaNuevaFila = async () => {
    let newRowData = [...detalles];
    let index = -(detalles?.length + 1);
    const newData = {
        IdVacanteDetalle: index,
        NoVacante: selected[0]?.NoVacante,
        DateCreateStr: new Date(),
        IdStatus: 86,
        StatusName: 'Creado',
        IdAspirante: null,
        NombreCompleto: '',
        Edad: null,
        AspiracionSalarial: null,
        AniosExperiencia: null,
        GradoAcademico: '',
        Posicion: selected[0]?.Posicion,
        DateEntrevistaStr: null,
        IdUsersEntrevisa: null,

        // Booleans del checklist
        NotificacionIngreso: false,
        Entrevista: false,
        SolicitudConFoto: false,
        Demografica: false,
        Contrato: false,
        EvaluacionLogica: false,
        CopiaVacunas: false,
        EvaluacionMedica: false,
        Curriculum: false,
        CopiaDiploma: false,
        AntecedentesPoliciales: false,
        AntecedentesPenales: false,
        ConstanciasTrabajo: false,
        CartasReferencias: false,
        Croquis: false, 
        CopiaIdentidades: false,
        IdentidadPropia: false,
        CopiaRTN: false,
        InformacionAperturaCuentas: false,
        ManualInduccion: false,
        ManualInduccion: false,
        InfromacionGeneral: false,
        InduccionFormasPagos: false,
        ResenaHistorica: false,

    };

    newRowData.push(newData);
    setDetalles(newRowData);
  };

  const agregarDatosEntrevista = async (values) => {
    let nuevosDetalles = [...detalles];
    const index = nuevosDetalles.findIndex(detalle => detalle.IdVacanteDetalle === detalleSelected);

    if (index !== -1) {
      nuevosDetalles[index] = {
        ...nuevosDetalles[index],
        ...values 
      };
    }
    setDetalles(nuevosDetalles)

    if(detalleSelected > 0){
      agregarDetalle(nuevosDetalles)
      // setTimeout(() => {
      //     changeEntrevista(detalleSelected, true)
      // }, 500);
    }
    setDetalleSelected(null)
    setChecked(null)
    setDialogEntrevista(false)
  }

  const handleCheckbox = (e, rowData, field) => {
    let IdVacanteDetalle = rowData?.IdVacanteDetalle;
    let selectedFilter = selectedDetalles?.filter(i => i?.IdVacanteDetalle > 0)

    if(field === 'Entrevista'){
        if(selectedDetalles.length > 1){
            toastShow(toast, 'warn', 'Advertencia','Seleccione solo un detalle.')
            return
        }
        if(e?.checked){
            setChecked(e?.checked)
            setDetalleSelected(IdVacanteDetalle)
            setDialogEntrevista(true)
        }else{
            confirmDialog({
                message: `¿Esta seguro que cambiar el estado de ${field} para ${selectedFilter?.length > 1 ? selectedFilter?.length +' Detalles guardados' : '1 Detalle guardado'}?`,
                header: "Editar Check List",
                icon: "pi pi-exclamation-triangle",
                acceptLabel: "Sí",
                rejectLabel: "No",
                style: { backgroundColor: "white" },
                accept: async () => {
                    setLoading(true)
                    changeEntrevista(IdVacanteDetalle, e?.checked)
                    getValoresIniciales()
                    setSelectedDetalles([])
                    setLoading(false)
                },
                reject: () => {},
            });
        }
        return
    }

    if (IdVacanteDetalle > 0) {
      confirmDialog({
        message: `¿Esta seguro que cambiar el estado de ${field} para ${selectedFilter?.length > 1 ? selectedFilter?.length +' Detalles guardados' : '1 Detalle guardado'}?`,
        header: "Editar Check List",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        rejectLabel: "No",
        style: { backgroundColor: "white" },
        accept: async () => {
          setLoading(true)
          if(selectedFilter.length <= 0){
            changeCheckList(IdVacanteDetalle, field, e.checked)
          }else{
            selectedFilter.forEach(item => {
              changeCheckList(item?.IdVacanteDetalle, field, e.checked)
            });
          }
          toastShow(toast, 'success', 'Actualizado', 'Campo actualizado correctamente.')
          getValoresIniciales()
          setSelectedDetalles([])
          setLoading(false)
        },
        reject: () => {},
      });
    } else {
        const nuevosDetalles = detalles.map(detalle => {
            if (detalle === rowData) {
                return {
                    ...detalle,
                    [field]: e.checked
                };
            }
            return detalle;
        });

        setDetalles(nuevosDetalles);
    }
  };

  const handleCheckboxChange = (e, id) => {
    if (e.checked) {
      setIdCheckList((prevState) => [...prevState, id]);
    } else {
      setIdCheckList((prevState) => prevState.filter((item) => item !== id));
    }
  };
  
  const changeEstado = ({ data, api }) => {
    return (
      <div>
        <Dropdown
          value={estados.filter((e) => e.IdStatus === data.IdStatus)[0]}
          options={estados}
          optionLabel="StatusName"
          filter
          filterBy="StatusName"
          style={{ width: "100%" }}
          onChange={(e) => {
            let changes = [];
            if (selectedDetalles.length > 0) {
              changes = selectedDetalles.map((item) => {
                return {
                  IdVacanteDetalle: item.IdVacanteDetalle,
                  IdStatus: e.value.IdStatus,
                  StatusName: e.value.StatusName,
                };
              });
            } else {
              changes.push({
                IdVacanteDetalle: data.IdVacanteDetalle,
                IdStatus: e.value.IdStatus,
                StatusName: e.value.StatusName,
              });
            }
            confirmDialog({
              message: `¿Cambiar a estado ${e.value.StatusName} a ${changes.length} Vacantes ?`,
              header: "Confirmación",
              icon: "pi pi-exclamation-triangle",
              accept: async () => {
                let IdVacanteDetalles = changes.map((item) => item.IdVacanteDetalle);
                cambiarEstado(e.value.IdStatus, IdVacanteDetalles.toString());
                api.stopEditing();
              },
              reject: () => {},
            });
          }}
        />
      </div>
    );
  };
  
  const cambiarEstado = async (IdStatus, IdVacanteDetalles) => {
    const result = await chageEstadoVacantesDetalles({ IdStatus, IdVacanteDetalles });
    toastShow(toast, "success", "Actualizado", "Estado cambiado exitosamente");
    getValoresIniciales();
    setSelectedDetalles([]);
  };
  
  const columnsDet = [
    {
      field: "IdVacanteDetalle",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      frozen: 1,
    },
    {
      field: "NoVacante",
      headerEn: "Vacante",
      header: "Vacante",
      frozen: 1,
      className: "Xsmall",
      Format: "Modal",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdVacanteDetalle > 0) {
          setDialogDetalleUnico(true);
          setSelectedDetalles([data]);
        }
      },
    },
    {
      field: "DateCreateStr",
      headerEn: "Date Create",
      header: "Fecha Creado",
      Format: "DateTime",
      frozen: 1,
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      frozen: 1,
      className: "Xsmall",
      Format: "Estado",
      body: (rowData) => ({
        ID: rowData.IdStatus,
        Estado: rowData.StatusName,
      }),
      cellEditor: changeEstado,
      editable: true,
    },
    {
      field: "NombreCompleto",
      headerEn: "Candidato",
      header: "Candidato",
      className: "Xlarge",
      Format: "AutoComplete",
      items: aspirantesList,
      editable: false,
      value: "IdAspirante",
      label: "NombreCompleto",
      onChange: ({
          state,
          data: rowData,
          value,
          label,
          api,
          items,
          oldValue,
        }) => {
          let row = { ...rowData };
          let tempo = [...detalles];
          if (state?.IdAspirante !== oldValue?.IdAspirante) {
            if (row.IdVacanteDetalle) {
              row.IdAspirante = state?.IdAspirante;
              row.NombreCompleto = state?.NombreCompleto;
              row.Edad = state?.Edad;
              row.AniosExperiencia = state?.AniosExperiencia;
              row.AspiracionSalarial = state?.AspiracionSalarial;
              row.GradoAcademico = state?.GradoAcademico;
              const index = detalles.findIndex((d) => d.IdVacanteDetalle === row.IdVacanteDetalle);
              tempo[index] = row;
            }
          }else{
            return
          }
          setDetalles(tempo)
      }
    },
    {
      field: "",
      filter: false,
      header: "",
      className: "XXsmall",
      Format: "Template",
      body: (rowData) =>
        rowData.IdAspirante > 0 ? (
          <div style={{display: "flex",justifyContent: "center",alignItems: "center",}}>
            <Button
              icon="pi pi-info-circle"
              className="p-button-text"
              onClick={(e) =>{
                setDialogCandidato(true)
                setAspirante([rowData])
              }}
              tooltip="Información Candidato"
              tooltipOptions={{position: "top"}}
            />
          </div>
        ) : (
        ""
      ),
    },
    {
      field: "Edad",
      headerEn: "Ege",
      header: "Edad",
      className: "Xsmall",
      Format: 'Currency',
    },
    {
      field: "AspiracionSalarial",
      header: "Aspiración Salarial",
      headerEn: "Salary Aspiration",
      className: "Xsmall",
      Format: 'Currency',
    },
    {
      field: "AniosExperiencia",
      header: "Experiencia (Años)",
      headerEn: "Expirience (Years)",
      Format: 'Currency',
      className: "Xsmall",
    },
    {
      field: "GradoAcademico",
      header: "Grado Académico",
      headerEn: "Grado Académico",
      className: "small",
    },
    {
      field: "Posicion",
      headerEn: "Position",
      header: "Posición",
      className: "small",
    },
    {
      headerName: 'Check List para Expediente',
      children: [
        {
          field: "NotificacionIngreso",
          header: "Notificación de Ingreso",
          headerEn: "Admission Notification",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.NotificacionIngreso} disabled/>
              </div>
            ),
        },
        {
          field: "Entrevista",
          header: "Entrevista",
          headerEn: "Interview",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.Entrevista} disabled />
              </div>
            ),
        },
        {
          field: "SolicitudConFoto",
          header: "Solicitud con Foto",
          headerEn: "Application with Photo",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.SolicitudConFoto} disabled />
              </div>
            ),
        },
        {
          field: "Demografica",
          header: "Ficha Demográfica",
          headerEn: "Demographic Sheet",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.Demografica} disabled />
              </div>
            ),
        },
        {
          field: "Contrato",
          header: "Contrato",
          headerEn: "Contract",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.Contrato} disabled />
              </div>
            ),
        },
        {
          field: "EvaluacionLogica",
          header: "Evaluación Lógica",
          headerEn: "Logic Evaluation",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.EvaluacionLogica} disabled />
              </div>
            ),
        },
        {
          field: "CopiaVacunas",
          header: "Copia de Vacunas",
          headerEn: "Vaccination Record Copy",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.CopiaVacunas} disabled />
              </div>
            ),
        },
        {
          field: "EvaluacionMedica",
          header: "Evaluación Médica",
          headerEn: "Medical Evaluation",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.EvaluacionMedica} disabled />
              </div>
            ),
        },
        {
          field: "Curriculum",
          header: "Currículum",
          headerEn: "Curriculum Vitae",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.Curriculum} disabled />
              </div>
            ),
        },
        {
          field: "CopiaDiploma",
          header: "Copia de Diploma",
          headerEn: "Diploma Copy",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.CopiaDiploma}  disabled/>
              </div>
            ),
        },
        {
          field: "AntecedentesPoliciales",
          header: "Ant. Policiales",
          headerEn: "Police Record",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.AntecedentesPoliciales} disabled />
              </div>
            ),
        },
        {
          field: "AntecedentesPenales",
          header: "Ant. Penales",
          headerEn: "Criminal Record",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.AntecedentesPenales} disabled />
              </div>
            ),
        },
        {
          field: "ConstanciasTrabajo",
          header: "Constancias de Trabajo",
          headerEn: "Employment Letters",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.ConstanciasTrabajo} disabled />
              </div>
            ),
        },
        {
          field: "CartasReferencias",
          header: "Cartas de Referencia",
          headerEn: "Reference Letters",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.CartasReferencias} disabled />
              </div>
            ),
        },
        {
          field: "Croquis",
          header: "Croquis de Dirección",
          headerEn: "Address Map",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.Croquis} disabled />
              </div>
            ),
        },
        {
          field: "CopiaIdentidades",
          header: "Copia de Identidades",
          headerEn: "ID Copies",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.CopiaIdentidades} disabled />
              </div>
            ),
        },
        {
          field: "IdentidadPropia",
          header: "Identidad Original",
          headerEn: "Original ID",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.IdentidadPropia} disabled />
              </div>
            ),
        },
        {
          field: "CopiaRTN",
          header: "Copia de RTN",
          headerEn: "RTN Copy",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.CopiaRTN} disabled />
              </div>
            ),
        },
        {
          field: "InformacionAperturaCuentas",
          header: "Info. Apertura Cuenta",
          headerEn: "Bank Account Info",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.InformacionAperturaCuentas} disabled />
              </div>
            ),
        },
        {
          field: "ManualInduccion",
          header: "Manual de Inducción",
          headerEn: "Induction Manual",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.ManualInduccion} disabled />
              </div>
            ),
        },
        {
          field: "InfromacionGeneral",
          header: "Información General",
          headerEn: "General Info",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.InfromacionGeneral} disabled />
              </div>
            ),
        },
      ]
    },
    {
      field: "PorcentajeCompletado",
      headerEn: "Porcentage",
      header: "Porcentaje",
      Format: 'Porcentaje',      
      frozen: 1,
      alignFrozen: "right",
      className: 'Xsmall',
    },
    {
      field: "IdVacanteDetalle",
      header: "",
      Format: "Botones",
      filter: false,
      frozen: 1,
      alignFrozen: "right",
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          tooltipOptions: { position: "left" },
          disabled: (rowData) => rowData?.IdStatus !== 87,
          onClick: (rowData) => {
            if(rowData?.IdStatus === 87){
              toastShow(toast, 'warn', 'Advertencia','No se permite editar detalles en estado "No Aplica".')
              return
            }
            if (rowData?.IdVacanteDetalle > 0) {
              setDialogDetalleUnico(true);
              setSelectedDetalles([rowData]);
            }
          },
        },
      ],
    },
  ];

  const tableDet = {
    Columns: columnsDet,
    Data: detalles,
    selected: selectedDetalles,
    setSelected: setSelectedDetalles,
    showModal: () => {},
  };

  const agregarEntrevista = () =>{
    const nuevaEntrevista = {
      IdEntrevista: -Math.floor(Math.random() * 10000), 
      IdUserEntrevista: null,
      ComentarioEntrevista: null,
      DateEntrevista: new Date(),
      IdUserEdit: userAuth?.IdUser,
    };

    setEntrevistas([...entrevistas, nuevaEntrevista]);
  }

  const columnsEntrevistas = [
    {
      field: "IdEntrevista",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      frozen: 1,
    },
    {
      field: "DateEntrevista",
      headerEn: "Date Entrevista",
      header: "Fecha Entrevista",
      header: "Fecha Creado",
      Format: "Date",
      editable: true,
    },
    {
      field: "UserNameEntrevista",
      headerEn: "Entrevistador",
      header: "Entrevistador",
      className: "large",
      editable: true,
      Format: "AutoComplete",
      items: usuarios,
      value: "IdUser",
      label: "UserName",
      field: "UserName",
    },
    {
      field: "ComentarioEntrevista",
      header: "Comentario",
      headerEn: "Comment",
      className: "Xlarge",
      flex: 1,
      editable: true,
    },
    {
      field: "IdEntrevista",
      header: "",
      Format: "Botones",
      filter: false,
      frozen: 1,
      alignFrozen: "right",
      Botones: [
        {
          icon: "pi pi-trash",
          tooltip: "Eliminar",
          tooltipOptions: { position: "left" },
          onClick: (rowData) => {
            if (rowData?.IdEntrevista < 0) {
              setEntrevistas((prev) => prev.filter((e) => e.IdEntrevista !== rowData?.IdEntrevista));
            }else{
              confirmDialog({
                message: `¿Está seguro de eliminar la entrevista?`,
                header: "Eliminar Entrevista",
                icon: "pi pi-exclamation-triangle",
                acceptLabel: "Sí",
                rejectLabel: "No",
                style: { backgroundColor: "white" },
                accept: async () => {
                  eliminarEnt(rowData?.IdEntrevista)
                },
                reject: () => {},
              });
            }
          },
        },
      ],
    },
  ];

  const tableEntrevistas = {
    Columns: columnsEntrevistas,
    Data: entrevistas,
    showModal: () => {},
  };

  const eliminarEnt = async (IdEntrevista) => {
    setLoading2(true)
    const resp = await eliminarEntrevista(IdEntrevista);
    toastShow(toast, "success", "Eliminado", "Entrevista eliminada correctamente");
    getValoresInicialesDialog()
    setLoading2(false)
  }

  useEffect(() => {
    if (showDialogDetalles) {
      getValoresIniciales();
    }
  }, [showDialogDetalles]);

  useEffect(() => {
    if (dialogDetalleUnico) {
      getValoresInicialesDialog();
    }
  }, [dialogDetalleUnico]);

  useEffect(() => {
    if(values?.NombreCompleto?.IdAspirante){
      setValues({
        ...values,
        Edad: values?.NombreCompleto?.Edad,
        AspiracionSalarial: values?.NombreCompleto?.AspiracionSalarial,
        AniosExperiencia: values?.NombreCompleto?.AniosExperiencia,
        GradoAcademico: values?.NombreCompleto?.GradoAcademico,
      })
    }else{
      setValues({
        ...values,
        Edad: null,
        AspiracionSalarial: null,
        AniosExperiencia: null,
        GradoAcademico: '',
      })
    }
  }, [values?.NombreCompleto?.IdAspirante]);


  const dialogTitle = `Agregar Detalle a la vacante ${selected[0]?.NoVacante}`;

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide2}
      />
      <Button
        label={selectedDetalles[0]?.IdVacanteDetalle > 0 ? 'Editar' : "Guardar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={otraFuncionDeGuardar}
      />
    </React.Fragment>
  );

  return (
    <div>
      <Dialog
        visible={showDialogDetalles}
        onHide={onHide}
        header={dialogTitle}
        style={{ width: "92%", height: '80%' }}
      >
        <Toast ref={toast} />
        <div id="DialogDetalles">
          <Loader loading={loading} querySelector={"#DialogDetalles"} />
          <div className="d-flex gap-2 mb-2">
            <Button icon="pi pi-refresh" onClick={getValoresIniciales} />
            <Button icon="pi pi-plus" onClick={() => {setDialogDetalleUnico(true)}} /> 
            {/* <Button icon="pi pi-save" onClick={agregarDetalle} disabled={detalles.length <= 0}/> */}
            <Button icon="pi pi-times" className="p-button-danger" onClick={eliminarDetalles} disabled={selectedDetalles.length === 0}/>
          </div>
          <div style={{height: '65vh'}}>
            <AgGrid table={tableDet} />
          </div>
        </div>
      </Dialog>
              
      {dialogEntrevista && (
        <EntrevistaModal
          showDialog={dialogEntrevista}
          setShowDialog={setDialogEntrevista}
          getInfo={getValoresIniciales}
          checked={checked}
          detalleSelected={detalleSelected}
          setChecked={setChecked}
          agregarDatosEntrevista={agregarDatosEntrevista}
        />
      )}

      {dialogCandidato && (
        <CandidatosCRUD
          showDialog={dialogCandidato}
          setShowDialog={setDialogCandidato}
          getInfo={()=>{}}
          selected={aspirante}
          setSelected={setAspirante}
          modo={aspirante?.length > 0  ? "Editar" : "Crear"}
          editable={false}
        />
      )}

      <Dialog
        visible={dialogDetalleUnico}
        onHide={onHide2}
        header={selectedDetalles[0]?.IdVacanteDetalle > 0 ? 'Editar Candidato' :"Agregar Candidato"}
        style={{ width: "60%", height: '99%' }}
        footer={DialogFooter}
      >
        <Toast ref={toast} />
        <div id="DialogDetallesUnico">
          <Loader loading={loading2} querySelector={"#DialogDetallesUnico"} />
          <div>

            {/* INFROMACION ASPIRANTE */}
            <div className="d-flex mx-4">
              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"NombreCompleto"}
                    value={values.NombreCompleto}
                    items={aspirantesList}
                    field={"NombreCompleto"}
                    label={"Candidato"}
                    handleInputChange={handleInputChange}
                    className={error.IdAspirante ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputNumber
                    name="Edad"
                    value={values.Edad}
                    minFractionDigits={2}
                    disabled
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Edad ? "p-invalid" : ""}
                  />
                  <label htmlFor="Edad">Edad (Años)</label>
                </span>
              </div>
            </div>
            <div className="d-flex mx-4">
              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputNumber
                    name="AspiracionSalarial"
                    value={values.AspiracionSalarial}
                    disabled
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    minFractionDigits={2}
                    className={error.AspiracionSalarial ? "p-invalid" : ""}
                  />
                  <label htmlFor="AspiracionSalarial">Aspiracion Salarial</label>
                </span>
              </div>

              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputNumber
                    name="AniosExperiencia"
                    value={values.AniosExperiencia}
                    minFractionDigits={2}
                    disabled
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.AniosExperiencia ? "p-invalid" : ""}
                  />
                  <label htmlFor="AniosExperiencia">Años de Experiencia</label>
                </span>
              </div>
            </div>
            <div className="d-flex mx-4">
              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="GradoAcademico"
                    value={values.GradoAcademico}
                    disabled
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.GradoAcademico ? "p-invalid" : ""}
                  />
                  <label htmlFor="GradoAcademico">Grado Académico</label>
                </span>
              </div>

              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Posicion"
                    value={selected[0]?.Posicion}
                    disabled
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                  />
                  <label htmlFor="Posicion">Posición</label>
                </span>
              </div>
            </div>

            {/* CARD CHECK LIST */}
            <div className="mx-4 mt-4">
              <Card
                titulo={<h5>Check list para expediente</h5>}
                contenido={
                  <div className="row mt-2">
                    {checkList.map((item) => (
                      <div key={item.IdCheck} className="col-4 mb-2">
                        <div className="form-check">
                          <Checkbox
                            id={item.IdCheck}
                            name={item.IdCheck}
                            checked={IdCheckList.includes(item.IdCheck)}
                            onChange={(e) => handleCheckboxChange(e, item.IdCheck)}
                          />
                          <span className="mx-2">{item.CheckList}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                }
              />
            </div>


            {IdCheckList.includes(2) && (
              <div className="d-flex mt-2">
                <div style={{width: '2%'}} className="mx-4">
                  <Button
                    icon="pi pi-plus"
                    className="p-button-success"
                    onClick={() => agregarEntrevista()}
                    tooltip="Agregar"
                    tooltipOptions={{position: "top"}}
                  />
                </div>
                <div style={{width: '98%'}}>
                  <div style={{height: '28vh'}} className="mx-4">
                    <AgGrid table={tableEntrevistas} />
                  </div>
                </div>
              </div>
            )}



            {/* {IdCheckList.includes(2) && (
              <div className="d-flex mx-4">
                <div className="field col-6 me-2 mt-2">
                  <span className="p-float-label">
                    <Calendar
                      id="DateEntrevista"
                      name="DateEntrevista"
                      value={values?.DateEntrevista}
                      dateFormat="dd/mm/yy"
                      mask="99/99/9999"
                      style={{ width: '100%' }}
                      maxDate={new Date()}
                      onChange={(e) => handleInputChange(e, 'DateEntrevista')}
                      showIcon
                      className={error.DateEntrevista ? 'p-invalid' : ''}
                    />
                    <label htmlFor="DateEntrevista">Fecha Entrevista</label>
                  </span>
                </div>

                <div className="field col-6 me-2 mt-2">
                  <span className="p-float-label">
                    <MultiSelectDropdown
                      name="UserName"
                      value={selectedUsers}
                      setValue={setSelectedUsers}
                      items={usuarios}
                      style={{ width: '100%' }}
                      field="UserName"
                      placeholder="Seleccione Entrevistador"
                      label="Entrevistador"
                      className={error.selectedUsers ? 'p-invalid' : ''}
                    />
                  </span>
                </div>
              </div>
            )}

            {IdCheckList.includes(2) && (
              <div className="d-flex mx-4">
                <div className="field col-12 me-2 mt-2">
                  <span className="p-float-label">
                    <InputText
                      name="ComentarioEntrevista"
                      value={values.ComentarioEntrevista}
                      onChange={handleInputChange}
                      style={{ width: '100%' }}
                      className={error.ComentarioEntrevista ? 'p-invalid' : ''}
                    />
                    <label htmlFor="ComentarioEntrevista">Comentario</label>
                  </span>
                </div>
              </div>
            )} */}

          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default DetallesVacantesCRUD;
